import React, { useEffect } from 'react';
import CompanyIntro from '../components/aboutpage/CompanyIntro';
import MissionSection from '../components/aboutpage/MissionSection';
import CoreValues from '../components/aboutpage/CoreValues';
import FounderMessage from '../components/aboutpage/FounderMessage';


const AboutPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
  return (
    <div className="min-h-screen pb-16">
      {/* Hero Section */}
      {/* <div className="text-center mb-10 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">

          <div className="absolute top-32 left-10 w-20 h-20 bg-red-500/10 rounded-full blur-xl"></div>
          <div className="absolute top-40 right-16 w-16 h-16 bg-red-400/8 rounded-full blur-lg"></div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extralight text-gray-900 mb-6 tracking-tight leading-tight">
            About Us
          </h1>
          <p className="text-2xl text-gray-600 font-light mb-8 leading-relaxed">
            Building Dignified Communities for Tomorrow's Seniors
          </p>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[var(--primarycolor)] to-transparent mx-auto"></div>
        </div>
      </div> */}

      <CompanyIntro />
      <MissionSection />
      <CoreValues />
      <FounderMessage />
    </div>
  );
};

export default AboutPage;